module.exports = __webpack_public_path__ + "static/media/insurecomp_mainlogo_var2.4597e2dd.png";